<template>
  <main>
    <slot />
  </main>
</template>
<script setup lang="ts"></script>
<style>
main {
  font-family: Inter, sans-serif;
  background-color: #f0f2f5;
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 1rem;
  padding-top: 1rem;
  justify-items: center;
}

.width-md {
  width: 95vw;
  max-width: 725px;
}
</style>
